import type { ItemSidebarMenu } from 'context/user-role/types';

import { MENU_KEYS, SCREENS_KEYS } from 'constants/constants';
import { INVESTMENT_OFFICES } from 'constants/globals';

const typeAccess = {
  edit: 'edit',
  readOnly: 'readOnly',
  blocked: 'blocked',
};

const accessRolesDefault = {
  banquero: typeAccess.blocked,
  operaciones: typeAccess.blocked,
  apertura: typeAccess.blocked,
  pld: typeAccess.blocked,
  venta: typeAccess.blocked,
  socio: typeAccess.blocked,
  otro: typeAccess.blocked,
};

export const PERMISSIONS_BY_MENU: ItemSidebarMenu[] = [
  {
    menuName: 'Home',
    menuKey: MENU_KEYS.home,
    accessRoles: {
      banquero: typeAccess.edit,
      operaciones: typeAccess.edit,
      apertura: typeAccess.edit,
      pld: typeAccess.edit,
      venta: typeAccess.edit,
      socio: typeAccess.edit,
      otro: typeAccess.blocked,
    },
    options: [
      {
        screenName: 'Dashboard',
        screenKey: SCREENS_KEYS.dashboard,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.edit,
          apertura: typeAccess.edit,
          pld: typeAccess.edit,
          venta: typeAccess.edit,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
    ],
  },
  {
    menuName: 'Clientes',
    menuKey: MENU_KEYS.clients,
    accessRoles: {
      banquero: typeAccess.edit,
      operaciones: typeAccess.edit,
      apertura: typeAccess.edit,
      pld: typeAccess.edit,
      venta: typeAccess.edit,
      socio: typeAccess.edit,
      otro: typeAccess.blocked,
    },
    options: [
      {
        screenName: 'Administraci\u00F3n',
        screenKey: SCREENS_KEYS.administration,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.edit,
          apertura: typeAccess.edit,
          pld: typeAccess.edit,
          venta: typeAccess.edit,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Onboarding',
        screenKey: SCREENS_KEYS.onboarding,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.edit,
          apertura: typeAccess.edit,
          pld: typeAccess.edit,
          venta: typeAccess.edit,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Posiciones',
        screenKey: SCREENS_KEYS.positions,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.edit,
          apertura: typeAccess.edit,
          pld: typeAccess.edit,
          venta: typeAccess.edit,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Portafolio',
        screenKey: SCREENS_KEYS.positionsPortafolio,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.edit,
          apertura: typeAccess.blocked,
          pld: typeAccess.edit,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Movimientos',
        screenKey: SCREENS_KEYS.positionsMovements,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.edit,
          apertura: typeAccess.blocked,
          pld: typeAccess.edit,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Rendimientos',
        screenKey: SCREENS_KEYS.positionsYields,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.edit,
          venta: typeAccess.edit,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Nuevo Cliente',
        screenKey: SCREENS_KEYS.newClient,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.edit,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Carga masiva',
        screenKey: SCREENS_KEYS.massUpload,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.edit,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
    ],
  },
  {
    menuName: 'Fondos',
    menuKey: MENU_KEYS.funds,
    accessRoles: accessRolesDefault,
    exclusiveByOffice: [INVESTMENT_OFFICES.SURA],
    options: [
      {
        screenName: 'Administraci\u00F3n',
        screenKey: SCREENS_KEYS.fundsAdministration,
        showSidebar: true,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Posiciones',
        screenKey: SCREENS_KEYS.fundsPositions,
        showSidebar: true,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Portafolio',
        screenKey: SCREENS_KEYS.positionsFundsPortfolio,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Movimientos',
        screenKey: SCREENS_KEYS.positionsFundsMovements,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Rendimientos',
        screenKey: SCREENS_KEYS.positionsFundsYields,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },
    ],
  },
  {
    menuName: 'Portafolios y Rebalanceo',
    menuKey: MENU_KEYS.portfolioRebalance,
    accessRoles: {
      banquero: typeAccess.edit,
      operaciones: typeAccess.blocked,
      apertura: typeAccess.blocked,
      pld: typeAccess.blocked,
      venta: typeAccess.edit,
      socio: typeAccess.edit,
      otro: typeAccess.blocked,
    },
    options: [
      {
        screenName: 'Portafolios',
        screenKey: SCREENS_KEYS.portfolio,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.edit,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Estrategia',
        screenKey: SCREENS_KEYS.strategy,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.edit,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Restricciones',
        screenKey: SCREENS_KEYS.restrictions,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.edit,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Rebalanceo',
        screenKey: SCREENS_KEYS.balancing,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Consolidado/Instituci\u00F3n',
        screenKey: SCREENS_KEYS.globalOrders,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
    ],
  },
  {
    menuName: 'Rebalanceo Fondos',
    menuKey: MENU_KEYS.rebalanceFunds,
    accessRoles: accessRolesDefault,
    exclusiveByOffice: [INVESTMENT_OFFICES.SURA],
    options: [
      {
        screenName: 'Portafolios',
        screenKey: SCREENS_KEYS.fundsPortfolio,
        showSidebar: true,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Estrategia',
        screenKey: SCREENS_KEYS.fundsStrategy,
        showSidebar: true,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Restricciones',
        screenKey: SCREENS_KEYS.fundsRestrictions,
        showSidebar: true,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Rebalanceo',
        screenKey: SCREENS_KEYS.fundsBalancing,
        showSidebar: true,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Consolidado/Instituci\u00F3n',
        screenKey: SCREENS_KEYS.fundsglobalOrders,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },
    ],
  },
  {
    menuName: 'Reportes',
    menuKey: MENU_KEYS.reports,
    accessRoles: {
      banquero: typeAccess.edit,
      operaciones: typeAccess.edit,
      apertura: typeAccess.edit,
      pld: typeAccess.blocked, // Todo: Once component is created, restrict routes access for pld role
      venta: typeAccess.blocked, // Todo: Once component is created, restrict routes access for venta role
      socio: typeAccess.edit,
      otro: typeAccess.blocked,
    },
    options: [
      {
        screenName: 'Operativo',
        screenKey: SCREENS_KEYS.operationReports,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.edit,
          apertura: typeAccess.edit,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Inversi\u00F3n',
        screenKey: SCREENS_KEYS.investment,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.edit,
          apertura: typeAccess.edit,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Honorarios',
        screenKey: SCREENS_KEYS.fee,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.edit,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Documental',
        screenKey: SCREENS_KEYS.documentary,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.edit,
          pld: typeAccess.edit,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Fondos',
        screenKey: SCREENS_KEYS.reportsFounds,
        showSidebar: true,
        accessRoles: accessRolesDefault,
        exclusiveByOffice: [INVESTMENT_OFFICES.SURA],
      },
      {
        screenName: 'Liquidez',
        screenKey: SCREENS_KEYS.liquidityReport,
        showSidebar: true,
        accessRoles: accessRolesDefault,
      },
    ],
  },
  {
    menuName: 'Administraci\u00F3n / Gesti\u00F3n',
    menuKey: MENU_KEYS.administrationManagement,
    accessRoles: {
      banquero: typeAccess.blocked,
      operaciones: typeAccess.edit,
      apertura: typeAccess.edit,
      pld: typeAccess.edit,
      venta: typeAccess.edit,
      socio: typeAccess.edit,
      otro: typeAccess.blocked,
    },
    options: [
      {
        screenName: 'Cumplimiento',
        screenKey: SCREENS_KEYS.compliance,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.edit,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Operaciones',
        screenKey: SCREENS_KEYS.complianceOperaciones,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.edit,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Restringidos',
        screenKey: SCREENS_KEYS.complianceRestringidos,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.edit,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Servicios',
        screenKey: SCREENS_KEYS.complianceServices,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.edit,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Auditorias',
        screenKey: SCREENS_KEYS.complianceAudits,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.edit,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Prácticas de venta',
        screenKey: SCREENS_KEYS.complianceSales,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.edit,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Riesgo',
        screenKey: SCREENS_KEYS.complianceRiskAssessment,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Operaciones Inusuales',
        screenKey: SCREENS_KEYS.complianceUnusualOperations,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'EBR',
        screenKey: SCREENS_KEYS.complianceRiskAssessmentEbr,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Alertas',
        screenKey: SCREENS_KEYS.complianceAlertLog,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Reportes de operatividad',
        screenKey: SCREENS_KEYS.complianceOperationalReports,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Denuncias',
        screenKey: SCREENS_KEYS.complianceComplaints,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.edit,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Montos operados',
        screenKey: SCREENS_KEYS.complianceOperatedAmounts,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Alertas operativas',
        screenKey: SCREENS_KEYS.complianceOperationalAlerts,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },
      {
        screenName: 'Operación',
        screenKey: SCREENS_KEYS.operation,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.edit,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Carga',
        screenKey: SCREENS_KEYS.operationLoad,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.edit,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Emisora',
        screenKey: SCREENS_KEYS.operationEmisora,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.edit,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Movimientos',
        screenKey: SCREENS_KEYS.operationMovements,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.edit,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Homologaci\u00F3n',
        screenKey: SCREENS_KEYS.operationHomologation,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.edit,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Validación de carga',
        screenKey: SCREENS_KEYS.operationAuditLoadValidation,
        showSidebar: false,
        accessRoles: accessRolesDefault,
      },

      /*  {
        screenName: 'Precios',
        screenKey: SCREENS_KEYS.operationPrices,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.edit,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Filtros',
        screenKey: SCREENS_KEYS.operationFilters,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.edit,
          operaciones: typeAccess.edit,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },*/
      {
        screenName: 'Configuraci\u00F3n',
        screenKey: SCREENS_KEYS.configuration,
        showSidebar: true,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Usuarios',
        screenKey: SCREENS_KEYS.configurationUsers,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Roles',
        screenKey: SCREENS_KEYS.configurationRoles,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Grupos',
        screenKey: SCREENS_KEYS.configurationGroups,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Perfiles',
        screenKey: SCREENS_KEYS.configurationProfiles,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Cumplimiento',
        screenKey: SCREENS_KEYS.configurationCompliance,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Eventos',
        screenKey: SCREENS_KEYS.configurationEvents,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Apariencia',
        screenKey: SCREENS_KEYS.configurationAppearance,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
      {
        screenName: 'Cat\u00E1logos',
        screenKey: SCREENS_KEYS.configurationCatalog,
        showSidebar: false,
        accessRoles: {
          banquero: typeAccess.blocked,
          operaciones: typeAccess.blocked,
          apertura: typeAccess.blocked,
          pld: typeAccess.blocked,
          venta: typeAccess.blocked,
          socio: typeAccess.edit,
          otro: typeAccess.blocked,
        },
      },
    ],
  },
];
